import { NearbyError } from "@mui/icons-material";
import {
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Typography,
  Avatar,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import { SettingsMasksSelection } from "../components/settings/SettingsMasksSelection";

import { PaddedPaper } from "../components/surfaces/PaddedPaper";
import { useBackgroundIndicator } from "../hooks/indicatorHooks";
import { useSettingsContext } from "../hooks/settingHooks";

export function SettingsPage() {
  const { t } = useTranslation();
  const {
    settings: { backgroundIndicators, masks },
  } = useSettingsContext();
  const [backgroundLayer, setBackgroundLayer] =
    useBackgroundIndicator(backgroundIndicators);

  return (
    <PaddedPaper>
      <Typography variant="subtitle2" color="white">
        {t("label.backgroundLayer")}
      </Typography>
      <List>
        {backgroundIndicators.map((indicator) => (
          <ListItemButton
            key={`baselayer-option-${indicator.id}`}
            selected={backgroundLayer?.id === indicator.id}
            onClick={() => setBackgroundLayer(indicator)}
            disabled={indicator.layers.length < 1}
          >
            <ListItemAvatar>
              <Avatar>
                <img
                  src={indicator.image}
                  alt={`${indicator.title} visualisation`}
                />
              </Avatar>
            </ListItemAvatar>
            <ListItemText color="white">{indicator.title}</ListItemText>
            {indicator.layers.length < 1 && <NearbyError />}
          </ListItemButton>
        ))}
      </List>
      {masks && masks.length > 0 && <SettingsMasksSelection masks={masks} />}
    </PaddedPaper>
  );
}
